<template>
  <div class="map-wrapper-container" ref="mapWrapperContainerRef">
    <div class="row">
      <div class="col-12 d-flex flex-wrap gap-1">
        <div
          v-for="(button, buttonIndex) of buttonList"
          :key="`button_${buttonIndex}`"
        >
          <button
            slot="reference"
            @click="clickMapButton(button)"
            :class="selectedObject.label === button.label ? 'active' : ''"
            class="btn-map-button btn btn-sm"
          >{{ button.label }}</button>
        </div>
      </div>
      <div class="col-12">
        <div
          ref="maptab"
          id="mapTab"
          class="">
          <div class="row">
            <div class="col-sm-12 col-md-6 col-lg-6">
              <div
                ref="mapTitleContainer"
                class="map-wrapper-title-container">
                <h3>{{mapTitle}} <span v-if="mapUnit">( {{mapUnit}} )</span></h3>
                <p class="desc-paragraph">{{ indicatorDescription }}</p>
              </div>
<!--               <map-chart
                :bubble-data="JSON.stringify(mapData)"
                :chart-options="JSON.stringify(mapOptions)"
                :metadata="JSON.stringify(mapMetadata)">
              </map-chart> -->
              <div>
                <multi-line-chart
                  :data="lineChartParams"
                  :chart-options="lineChartOptions"></multi-line-chart>
              </div>
            </div><!-- /.col -->
            <div class="col-sm-12 col-md-6 col-lg-6 container-bar-chart mt-3 mt-sm-0">
              <div ref="barChartRef">
                <bar-chart
                  v-bind="barChartParams"
                  @chartReady="isBarChartReady($event)">
                </bar-chart>
              </div>
              <div ref="dataLegendRef" class="container-data-legend">
                <div class="d-flex flex-row align-items-center fw-bold">
                  <i class="uil uil-list-ul me-1"></i> Data legend
                </div>
                <div
                  v-if="selectedAverageData"
                  class="container-average-line-legend fs-12 fw-light">
                  <div>
                    <span>ESCAP region average:</span>
                  </div>
                  <div class="d-flex gap-2 ">
                    <div
                      v-for="average in selectedAverageData"
                      :key="average.label"
                      class="d-flex align-items-center gap-1">
                      <span>{{ average.label }}</span>
                      <svg width="30" :height="average.strokeWidth">
                        <line
                          x1="0"
                          y1="0"
                          x2="30"
                          y2="0"
                          :stroke="average.stroke"
                          :stroke-dasharray="average.strokeDasharray"
                          :stroke-width="average.strokeWidth * 2"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
                <chart-legend
                  v-if="legendParams.input"
                  v-bind="legendParams"
                  class="py-1"
                ></chart-legend>
              </div>
            </div><!-- /.col -->
          </div><!-- /.row -->
        </div><!-- /#mapTab -->
      </div>
    </div>
  </div>
</template>

<script>
import BarChart from '@wc/bar-chart/bar-chart.vue';
import MapChart from '@wc/map-chart/map-chart.vue';
import MultiLineChart from '@wc/line-chart/spp-multi-line-chart.vue';
import ChartLegend from '@wc/spp-chart-legend/spp-chart-legend.vue';
import * as _ from 'lodash';
import axios from '@axios';
import 'vue-popperjs/dist/vue-popper.css';
import { ResizeObserver } from '@wc/chart-services';

const ESCAP_API_URL = process.env.VUE_APP_ESCAPAPI_URL;

export default {
  components: {
    BarChart,
    ChartLegend,
    MultiLineChart
    // MapChart
  },
  props: {
    renderAfter: { type: String }
  },
  data: function () {
    return {
      buttonList: [
        { label: 'SDG 7.1.1', indic: '7794', unit: '2554', source: '50' },
        { label: 'SDG 7.1.2', indic: '7795', unit: '2554', source: '50' },
        { label: 'SDG 7.2.1', indic: '7796', unit: '1469', source: '50' },
        { label: 'SDG 7.3.1', indic: '5112', unit: '4662', source: '50' },
        { label: 'SDG 7.a.1', indic: '6782', unit: '7066', source: '50' },
        { label: 'SDG 7.b.1', indic: '4727', unit: '7092', source: '50' }
      ],
      selectedObject: { label: 'SDG 7.1.1', indic: '7794', unit: '2554', source: '50' },
      colorCodes: {
        '0-20': '#ffffb2',
        '21-40': '#fed976',
        '41-60': '#feb24c',
        '61-80': '#fd8d3c',
        '81-100': '#f03b20'
      },
      colorLookup: [],
      mapOptions: {
        url: 'https://geoservices.un.org/arcgis/rest/services/ClearMap_WebGray/MapServer/tile/{z}/{y}/{x}',
        tmsUrl: null,
        geoJsonUrl: null,
        height: this.height,
        width: this.width,
        zoom: 3,
        minZoom: 2,
        maxZoom: 6,
        showMarker: false,
        showBubble: true,
        showLegend: true,
        tmsOptions: null,
        isShowControlPanel: true,
        isUnLockMouse: false,
        center: [17, 94]
      },
      mapMetadata: {
        colorField: 'value',
        radiusField: 'size',
        nameField: 'country',
        yearField: 'year',
        colorFieldLabel: 'Value',
        radiusFieldLabel: 'Size',
        yearFieldLabel: 'Year',
        colorFieldUnit: '',
        radiusFieldUnit: '%',
        colorConditions: undefined,
        tooltip: {
          value: '<b>\r\n [[name]] [[year]]\r\n</b>\r\n<br />\r\n[[colorFieldLabel]]: [[colorFieldValue]][[colorFieldUnit]]'
        }
      },
      mapData: {
        data: []
      },
      lineChartParams: {
        data: [],
        metadata: {
          x_datatype: 'datetime',
          y_datatype: 'number',
          name: 'Test Data',
          color: {
            ASPA: '#fcb900',
            'Asia Pacific': '#fcb900',
            WORLD: '#755a99'
          }
        }
      },
      lineChartOptions: {
        width: 960,
        height: 500,
        // margin: {
        //   bottom: chartMargin.bottom - 50,
        //   left: chartMargin.left - 30,
        //   right: 155
        // },
        rotateX: null, // 45,
        xField: 'x',
        xLabel: 'Year',
        yField: 'y',
        yLabel: 'Y label',
        isTrend: false,
        showLegend: false,
        timeFormat: '%Y', // d3.timeParse('%Y-%m-%dT%H:%M:%S%Z'),
        decimalPoint: 1,
        yAxisMin: 0,
        strokeThickness: 4,
        timeLabelFormat: '%Y',
        xUnitLabel: '',
        isHideHorizontalGridLine: true,
        isHideBorderTick: true,
        isYAxisHideDecimalValue: true,
        isYAxisHideDomain: false,
        isShowLineLabel: false,
        isShowLineNodeLabel: false
      },
      geoList: [],
      indicatorList: [],
      loadedChart: [],
      barChartParams: {
        autoWidth: true,
        height: 600,
        isHeightByData: true,
        isXAxisFixed: true,
        data: null,
        // orderByField: 'order',
        barOrientation: 'horizontal',
        zeroLabel: '0',
        decimalPoint: 1,
        barThickness: 15,
        averageLines: null,
        showAverageLineValueLabel: true,
        tooltipAtMousePosition: true,
        isWrapY: false
      },
      legendParams: { input: null },
      selectedAverageData: null,
      resizeObserver$: null
    };
  },
  computed: {
    mapTitle () {
      const indicator = this.indicatorList.find(e => {
        return e.INDIC_ID === this.selectedObject.indic &&
          e.UNIT_ID === this.selectedObject.unit;
      });

      if (!indicator) { return ''; }
      console.log('indicator', indicator);
      return indicator.alias;
    },
    mapUnit () {
      const indicator = this.indicatorList.find(e => {
        return e.INDIC_ID === this.selectedObject.indic &&
          e.UNIT_ID === this.selectedObject.unit;
      });

      if (!indicator) { return ''; }
      return indicator.Name_Unit;
    },
    indicatorDescription () {
      const indicator = this.indicatorList.find(e => {
        return e.INDIC_ID === this.selectedObject.indic &&
          e.UNIT_ID === this.selectedObject.unit;
      });

      if (!indicator) { return ''; }
      return indicator.short_definition;
    }
  },
  mounted () {
    setTimeout(() => {
      this.fetchMapData();
      const resizeObserverOptions = { skipFirst: false };
      this.resizeObserver$ = ResizeObserver.observe(this.$refs.mapWrapperContainerRef, () => {
        this.mapOptions.height = 0;
        this.adjustMapHeightByContainer();
      }, resizeObserverOptions);
    }, 250); // Waiting for HTML element rendering
  },
  methods: {
    fetchMapData: async function () {
      if (!this.geoList.length) {
        const geoListUrl = ESCAP_API_URL + '/countries/en';
        const fetchGeoList = await axios.get(geoListUrl);
        this.geoList = _.cloneDeep(fetchGeoList.data);
        // console.log('fetchGeoList', this.geoList);

        const indListUrl = ESCAP_API_URL + '/indicators/en/role/admin';
        const fetchIndList = await axios.get(indListUrl);
        this.indicatorList = _.cloneDeep(fetchIndList.data);
        // console.log('fetchGeoList', this.indicatorList);
      }

      const selectedIndicator = _.cloneDeep(this.selectedObject);
      const foundIndObj = this.indicatorList.find(e => {
        return e.INDIC_ID === selectedIndicator.indic &&
          e.UNIT_ID === selectedIndicator.unit;
      });

      const dataUrl = ESCAP_API_URL + '/data/';
      const dataUrlObj = {
        INDIC_ID: selectedIndicator.indic,
        UNIT_ID: selectedIndicator.unit,
        DATA_SOURCE_ID: selectedIndicator.source,
        role: 'admin'
      };
      const fetchData = await axios.post(dataUrl, dataUrlObj);
      const filteredRawData = _.filter(fetchData.data[0].data, (d) => {
        return d.type === 'country';
      });
      const mappedData = _.map(filteredRawData, (d) => {
        const foundObj = _.find(this.geoList, (g) => {
          return g.code === d.code;
        });
        d.region = foundObj.subregion_code;
        return d;
      });
      let filteredData = _.filter(mappedData, (d) => {
        return d.region;
      });

      const metadataUrl = ESCAP_API_URL + '/data/one_metadata';
      const metadataObj = {
        id: selectedIndicator.indic + '_' + selectedIndicator.unit + '_' + selectedIndicator.source,
        role: 'admin'
      };
      const fetchMetaData = await axios.post(metadataUrl, metadataObj);

      const maxYear = fetchMetaData.data[0].max_year;
      const minObj = _.minBy(filteredData, (d) => {
        return d.series[maxYear];
      });
      const maxObj = _.maxBy(filteredData, (d) => {
        return d.series[maxYear];
      });

      const minValue = minObj ? minObj.series[maxYear] : 0;
      const maxValue = maxObj ? maxObj.series[maxYear] : 0;
      this.getColorScale(minValue, maxValue);

      // console.log('minValue', maxYear, minValue, maxValue);

      filteredData = _.map(filteredData, (d) => {
        const value = d.series[maxYear];
        const foundColor = _.find(this.colorLookup, (c) => {
          return c.min <= value && c.max >= value;
        });
        d.value = value;
        d.color = foundColor ? foundColor.color : 'black';
        d.size = foundColor ? foundColor.size : 0;
        return d;
      });

      filteredData = _.filter(filteredData, (d) => {
        return d.value !== undefined;
      });

      const foundEscapObj = _.find(fetchData.data[0].data, (d) => {
        return d.code === 'ASPA';
      });

      const foundWorldObj = _.find(fetchData.data[0].data, (d) => {
        return d.code === 'WORLD';
      });

      const escapValue = foundEscapObj && foundEscapObj.series[maxYear] ? foundEscapObj.series[maxYear] : undefined;

      const worldValue = foundWorldObj && foundWorldObj.series[maxYear] ? foundWorldObj.series[maxYear] : undefined;

      // Format mapchart data
      this.mapMetadata.colorConditions = _.cloneDeep(this.colorCodes);

      const mapData = _.map(filteredData, (d) => {
        const foundCountry = _.find(this.geoList, (g) => {
          return g.code === d.code;
        });
        const value = d.series[maxYear];
        const obj = {
          value: value,
          country: d.name,
          year: maxYear,
          color: d.color,
          size: d.size,
          lat: foundCountry ? foundCountry.lat : 0,
          long: foundCountry ? foundCountry.long : 0
        };
        return obj;
      });

      this.mapData = {
        data: mapData
      };

      // Format barchart data
      const regionOrderMapping = {
        ENEA: 1,
        NOCA: 2,
        PACI: 3,
        SOEA: 4,
        SSWA: 5
      };

      const sortedData = _.sortBy(filteredData, [
        e => { return -regionOrderMapping[e.region]; },
        'value'
      ]);

      const barChartData = [];
      for (let index = 0; index < sortedData.length; index++) {
        const region = index === sortedData.length - 1 || (sortedData[index].region !== sortedData[index + 1].region)
          ? sortedData[index].region
          : null;
        const fmtItem = {
          label: sortedData[index].name,
          year: maxYear,
          percentage: sortedData[index].series[maxYear],
          color: sortedData[index].color,
          region: region
        };
        if (fmtItem.percentage !== undefined) {
          barChartData.push(fmtItem);
        }
      }

      // console.log('barChartData', barChartData);

      // Avg line
      const tempAverageLine = escapValue
        ? [
            { value: escapValue, label: 'Asia-Pacfific (ESCAP)', stroke: 'orange', strokeDasharray: null, strokeWidth: 2 }
          ]
        : [];

      this.barChartParams.averageLines = tempAverageLine.length
        ? tempAverageLine.map(e => {
          return {
            xVal: e.value,
            stroke: e.stroke,
            strokeDasharray: e.strokeDasharray,
            strokeWidth: e.strokeWidth,
            label: `${e.label} (${e.value}%)`
          };
        })
        : null;

      this.barChartParams.data = JSON.stringify({
        data: {
          tooltip: {
            value: '<strong>[[internal#label]]</strong> ([[internal#year]])<br>Value: [[internal#percentage]]'
          },
          // sort_order: 'DESC',
          data: barChartData
        }
      });

      // console.log('barChartData', this.barChartParams);

      const legendData = [];
      for (const [label, color] of Object.entries(this.colorCodes)) {
        legendData.push({
          label: label,
          color: color
        });
      }
      this.legendParams.input = JSON.stringify({ data: legendData });

      // Add world line
      tempAverageLine.push({
        value: escapValue,
        label: 'World',
        stroke: '#755a99',
        strokeDasharray: null,
        strokeWidth: 2
      });
      this.selectedAverageData = tempAverageLine;

      // Line chart
      const filteredRawLineData = _.filter(fetchData.data[0].data, (d) => {
        return ['WORLD', 'ASPA'].indexOf(d.code) > -1;
      });

      const lineData = _.map(filteredRawLineData, (d) => {
        const obj = {
          label: d.code === 'ASPA' ? 'Asia Pacific' : d.code,
          data: _.map(d.series, (v, k) => {
            return {
              x: k,
              y: Number(v)
            };
          })
        };
        return obj;
      });

      this.lineChartParams.data = lineData;
      this.lineChartOptions.yLabel = foundIndObj.Name_Unit;

      setTimeout(() => {
        this.adjustMapHeightByContainer();
      }, 250); // Wait for HTML rendering
    },
    getColorScale (min, max) {
      const result = {};
      const diff = max - min;
      const diffRange = Number((diff / 5).toFixed(1));
      const colors = ['#ffffb2', '#fed976', '#feb24c', '#fd8d3c', '#f03b20'];
      const sizes = [20, 40, 60, 80, 100];

      let curKey = min;
      this.colorLookup = [];
      for (let i = 0; i < 5; i++) {
        const next = i === 4 ? max : Number((curKey + diffRange - 0.1).toFixed(1));
        const key = Number(curKey).toLocaleString() + '-' + Number(next).toLocaleString();

        const obj = {
          min: curKey,
          max: next,
          size: sizes[i],
          color: colors[i]
        };
        this.colorLookup.push(obj);
        result[key] = colors[i];
        curKey = Number((curKey + diffRange).toFixed(1));
      }

      this.colorCodes = _.cloneDeep(result);
    },
    clickMapButton (buttonObj) {
      // this.filterPanelInputs.pageLevel.selectedObject.indicator = buttonObj.value;
      this.selectedObject = _.cloneDeep(buttonObj);
      this.fetchMapData();
    },
    adjustMapHeightByContainer () {
      const mapContainerHeight = this.$refs.maptab.offsetHeight;
      const mapTitleContainerHeight = this.$refs.mapTitleContainer.offsetHeight;
      const barContainerHeight = this.$refs.barChartRef.offsetHeight;
      const LegendContainerHeight = this.$refs.dataLegendRef.offsetHeight;

      let result = 500;

      // console.log('mapContainerHeight', mapContainerHeight);
      // console.log('mapTitleContainerHeight', mapTitleContainerHeight);
      if (this.height) {
        result = this.height;
      } else {
        result = (barContainerHeight + LegendContainerHeight) - (mapTitleContainerHeight + 20);
      }

      if (result < 100) {
        result = 500;
      }

      this.mapOptions.height = result;
    },
    isBarChartReady (self) {
      const regionTextMapping = {
        ENEA: 'ENEA',
        NOCA: 'NCA',
        PACI: 'PAC',
        SOEA: 'SEA',
        SSWA: 'SSWA'
      };

      self.vis[0].selectAll('.y-axis .tick').each(function (d) {
        if (d.region === null) { return; }
        const $tspan = document.createElementNS('http://www.w3.org/2000/svg', 'tspan');
        $tspan.textContent = regionTextMapping[d.region];
        const $text = document.createElementNS('http://www.w3.org/2000/svg', 'text');
        $text.setAttribute('dy', this.querySelector('text').getAttribute('dy'));
        $text.setAttribute('x', -self.marginLeft);
        $text.setAttribute('text-anchor', 'start');
        $text.style.fill = '#1890FF';
        $text.prepend($tspan);
        this.prepend($text);
      });
    }
  }
};

</script>

<style lang="scss">
// class here
.chart-box {
  min-height: 500px;
}
.desc-paragraph {
  min-height: 60px;
}
.container-data-legend {
  // display: none;
}
.map-wrapper-container {
  position: relative;
}
.map-tab-container {
  min-height: 1000px;
}
.tab-button {
  text-transform: uppercase;
  background-color: white !important;
  color: #2E2E2E !important;
  font-size: 14px;
  border-radius: 0;
  &.active {
    border-bottom: 2px solid #66CC33 !important;
  }
}
.button-label-container {
  text-align: left;
}
.button-list-container {
  display: flex;
  justify-content: center;
}
.btn-map-button {
  border-radius: 2px;
  font-weight: 400;
  border: 1px solid #D9D9D9;
  margin-right: 0.5rem;
  margin-bottom: 0.2rem;
  cursor: pointer;
  display: inline-block;
  padding: 0.4rem 1rem;
  font-size: .7rem;
  line-height: 1.7;
  letter-spacing: -.01rem;
  color: #000000;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-color: transparent;
  box-sizing: border-box;
  transform: translateY(0);
  transition: all .2s ease-in-out;
  &:hover {
    color: #000000;
    transform: scale(1.05);
    box-shadow: 0 10px 20px rgba(0,0,0,.12), 0 4px 8px rgba(0,0,0,.06);
  }
  &.active {
    color: #096DD9;
    // background-color: #9499a3;
    border-color: #096DD9;
    transform: translateY(0);
  }
}
</style>
